<template>
  <gj-modal
      :visible.sync="modalVisible"
      :confirm-loading="loading"
      size="normal"
      @cancel="cancel"
      @confirm="confirm"
  >
    <template #header>修改密码</template>
    <template #content>
      <el-form
          ref="form"
          :model="form"
          label-width="150px"
    >
      <el-form-item
          prop="pwd"
          :rules="[
            {required: true, message: '请输入新密码', trigger: ['blur', 'change']},
            $gjCustomRule(checkPwd())
          ]"
          style="margin-bottom: 16px"
      >
        <template #label>
          新密码
          <gj-help font-size="12px">
            密码格式：必须同时包含字母和数字，且长度在6-20位字符之间，区分大小写
          </gj-help>
        </template>
        <gj-input
            type="password"
            v-model="form.pwd"
            width="240px"
            placeholder="请输入包含字母和数字的6-20位字符"
        ></gj-input>
      </el-form-item>
      <el-form-item
          label="确认新密码"
          prop="confirmPwd"
          :rules="[
            {required: true, message: '请确认新密码', trigger: ['blur', 'change']},
            $gjCustomRule(checkConfirmPwd(form.pwd))
          ]"
      >
        <gj-input
            type="password"
            v-model="form.confirmPwd"
            width="240px"
            placeholder="请再次确定密码"
        ></gj-input>
      </el-form-item>
    </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {formRuleMixin, modalMixIn} from "../../../../minxins";
  import {isMeaningless} from "../../../../utils/common";
  import {editPassword} from "../../../../api/personal-center";
  import {USER_LOGOUT} from "../../../../store/action-types";

  export default {
    name: "edit-password",
    mixins: [modalMixIn, formRuleMixin],
    data() {
      return {
        loading: false,
        form: {
          confirmPwd: null,
          pwd: null,
        }
      }
    },
    methods: {
      checkPwd() {
        return (pwd) => {
          // if (pwd.length < 6 || pwd.length > 20) {
          //   return '密码长度限制为6-20个字符';
          // }
          //必须包含字母、数字，可以有（可有可没有）特殊字符  (x20是空格)
          const reg = /^(?=.*\d)(?=.*[A-Za-z])[\x21-\x7e]{6,20}$/;
          // const reg = /^(?![A-Z]+$)(?![a-z]+$)(?!\d+$)(?![\W_]+$)\S{6,16}$/;
          if (!reg.test(pwd)) {
            return '请输入格式正确的密码';
          }
          return null;
        }
      },
      checkConfirmPwd(pwd) {
        return (confirmPwd) => {
          if (isMeaningless(pwd)) {
            return '请先输入新密码';
          }
          if (pwd !== confirmPwd) {
            return '两次输入的密码不一致'
          }
          return null;
        }
      },
      confirm() {
        if (this.$gjFormValidate()) {
          this.loading = true;
          editPassword(this.form.pwd, this.form.confirmPwd)
            .then((res) => {
              if (res.code !== 0) {
                this.$gjMessage.error(res.msg);
              } else {
                this.$gjMessage.success('操作成功');
                this.$gjDestroy();
                this.logout();
              }
            }).complete(() => this.loading = false)
        }
      },
      logout() {
        this.$store.dispatch(USER_LOGOUT)
          .then(() => {
            this.$gjMessage({
              message: '退出成功',
              type: 'success',
              duration: 800
            });
          })
          .catch(() => {
            this.$gjMessage.error('退出失败');
          })
      }
    }
  }
</script>

<style scoped>

</style>
